import * as JsSIP from '@/components/Dispatching/VoIP/jssip-3.9.0'

export default {
    initialize,
    start,
    acceptCall,
    rejectCall,
    endCall,
    mute,
    unmute
}

var socket = null;
var userAgent = null;
var session = null;
var containerElement = null;
var conf = null;
var automaticAnswer = false;
var travellerCallbacks = null;

/* Parameters:
-Object containing the dispatcher's SIP client configuration
-HTML element that will contain the audio element for the call
-Object containing callback functions to be run when specific events are captured */
function initialize(config, audioContainer, callbacks) {
    conf = config;
    containerElement = audioContainer;
    travellerCallbacks = callbacks;
}

function start() {
    socket = new JsSIP.WebSocketInterface('wss://' + conf.pbxServer);

    let configuration = {
        sockets  : [ socket ],
        uri      : 'sip:'+ conf.sipExtension + '@' + conf.sipDomain,
        password : conf.sipPassword
    };
    userAgent = new JsSIP.UA(configuration);

    // Set listeners for events that require the VoIP phone to be notified via callbacks.
    userAgent.on('connected', travellerCallbacks.connected);
    userAgent.on('disconnected', travellerCallbacks.disconnected);
    userAgent.on('registered', travellerCallbacks.registered);
    userAgent.on('unregistered', travellerCallbacks.unregistered);
    userAgent.on('registrationFailed', travellerCallbacks.unregistered);

    userAgent.on('newMessage', travellerCallbacks.newMessage);

    userAgent.on('newRTCSession', onNewRTCSession);
    userAgent.start();
}

// Automatic answering should be limited to expected calls (self-initiated.)
function onNewRTCSession(e) {
    if (e.originator == 'remote') {
        if (automaticAnswer) {
            automaticAnswer = false;
            session = e.session;
            session.on('peerconnection', function(data) {
                // Set listener for "ontrack" event, i.e. when an incoming media stream is available.
                let connection = data.peerconnection;
                connection.ontrack = onRemoteStreamAvailable;
            });
            // Set listeners for events that require the VoIP phone to be notified via callbacks.
            //session.on('confirmed', travellerCallbacks.callConnected); // No event will notify when the other participant has actually answered the call.
            session.on('ended', travellerCallbacks.callEnded);
            session.on('failed', travellerCallbacks.callError);
            session.on('muted', function(data) {
                if (data.audio) {
                    travellerCallbacks.muted();
                }
            });
            session.on('unmuted', function(data) {
                if (data.audio) {
                    travellerCallbacks.unmuted();
                }
            });

            session.answer({ 'mediaConstraints': { 'audio': true, 'video': false } });
        }  else {
            e.session.terminate();
            //console.log('Unexpected call rejected');
        }
    }
}

function acceptCall() {
    automaticAnswer = true;
}

function rejectCall() {
    automaticAnswer = false;
}

function endCall() {
    if (session && session.isEstablished()) {
        session.terminate();
    }
	
	while (containerElement.firstChild) {
		containerElement.removeChild(containerElement.firstChild);
	}
}

function mute() {
    if (session && session.isEstablished()) {
        session.mute({ audio: true, video: true });
    }
}

function unmute() {
    if (session && session.isEstablished()) {
        session.unmute({ audio: true, video: true });
    }
}

function onRemoteStreamAvailable(e) {
	var audioElement = document.createElement('audio');
	audioElement.setAttribute('autoplay','');
	
	containerElement.appendChild(audioElement);
	if (audioElement.srcObject !== e.streams[0]) {
		audioElement.srcObject = e.streams[0];
	}
}